<template>
  <div class="row mt-1">
    <div class="col-lg-8 text-muted">

      <div>
        <small>Updated at Version: <strong>{{ versionNumber }}</strong></small>
        <small>Updated by: <strong>{{ updatedBy }}</strong></small>
        <small>Updated at: <strong>{{ block.updated_at | localDateTime }}</strong></small>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    block: Object,
    state: Object,
  },

  computed: {
    updatedBy() {
      if (this.block.user) {
        return this.block.user.fullname;
      }
      return this.block.counter_party.name;
    },

    versionNumber() {
      const operators = {
        even: (version) => version % 2 === 0,
        odd: (version) => version % 2 !== 0,
      };

      const ooperatorToUse = this.state.withCounterparty ? 'even' : 'odd';

      const majorVersion = Math.floor(this.block.version);

      if (operators[ooperatorToUse](majorVersion)) return `${Math.ceil(this.block.version)}.00`;

      return this.block.version;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
